import React, { Component } from 'react'

import ColumnTitle from '../ColumnTitle'

import hgtit from '../../assets/img/hgtit.png'

import { HistoricalWrapper, SwiperWrapper } from './style'

import Swiper from 'swiper'

import "../../../node_modules/swiper/swiper.min.css"

import img2014 from './../../assets/img/2014.png'
import img2015 from './../../assets/img/2015.png'
import img2016 from './../../assets/img/2016.png'
import img2017 from './../../assets/img/2017.png'
import img2018 from './../../assets/img/2018.png'
import img2019 from './../../assets/img/2019.png'
import img2020 from './../../assets/img/2020.png'

export default class Historical extends Component {

    componentDidMount() {
        let modify = 1;
        new Swiper('.swiper-container', {
            watchSlidesProgress: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            loopedSlides: 5,
            autoplay: true,
            // navigation: {
            //     nextEl: '.swiper-button-next',
            //     prevEl: '.swiper-button-prev',
            // },
            // pagination: {
            //     el: '.swiper-pagination',
            //     clickable :true,
            // },
            on: {
                progress: function (progress) {
                    for (let i = 0; i < this.slides.length; i++) {
                        const slide = this.slides.eq(i);
                        const slideProgress = this.slides[i].progress;
                        modify = 1;
                        if (Math.abs(slideProgress) > 1) {
                            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                        }
                        const translate = slideProgress * modify * 480 + 'px';
                        const scale = 1 - Math.abs(slideProgress) / 5;
                        const zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                        slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                        slide.css('zIndex', zIndex);
                        slide.css('opacity', 1);
                        if (Math.abs(slideProgress) > 3) {
                            slide.css('opacity', 0);
                        }
                    }
                },
                setTransition: function (transition) {
                    for (var i = 0; i < this.slides.length; i++) {
                        var slide = this.slides.eq(i)
                        slide.transition(transition);
                    }

                }
            }

        })
    }
    render() {
        return (
            <HistoricalWrapper>
                <ColumnTitle imgSrc={hgtit} />
                <SwiperWrapper>
                    <div className="swiper-container">
                        <div className="swiper-wrapper">
                            <div className="swiper-slide">
                                <img src={img2014} alt="" />
                            </div>
                            <div className="swiper-slide">
                                <img src={img2015} alt="" />
                            </div>
                            <div className="swiper-slide">
                                <img src={img2016} alt="" />
                            </div>
                            <div className="swiper-slide">
                                <img src={img2017} alt="" />
                            </div>
                            <div className="swiper-slide">
                                <img src={img2018} alt="" />
                            </div>
                            <div className="swiper-slide">
                                <img src={img2019} alt="" />
                            </div>
                            <div className="swiper-slide">
                                <img src={img2020} alt="" />
                            </div>
                        </div>

                    </div>
                </SwiperWrapper>
            </HistoricalWrapper>
        )
    }
}
